import { FC, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { ContentContainer } from '../../../components/custom_components/ContentContainer'
import '../index.less'
import { PerInfoBox } from '../../../components/custom_components/InfoBox'
import { InfoBoxTile } from '../../../components/custom_components/InfoBox/InfoBoxTileTemplate/InfoBoxTile'
import PerText from '../../../components/custom_components/Text'
import { useCollapse } from '../../../routes/collapse-context'
import { useAuth } from '../../../context/auth-context'
import { HrSupportState } from './types'
import { useHrSupportStore } from './HrSupportStore'
import { HrSupportHeader } from './HrSupportHeader'
import { HrSupportContent } from './HrSupportContent'
import { Country } from '../../../types'

export const HRSupportView: FC = () => {
  const { t } = useTranslation()
  const { user } = useAuth()
  const collapsed = useCollapse()
  const [initStore, storeInitialized] = useHrSupportStore((state: HrSupportState) => [state.initStore, state.storeInitialized])

  useEffect(() => {
    if (user && user.roles && user.roles.length) {
      const adminCountries = user.roles.filter((r) => r.includes('HR_ADMIN')).map((r) => r.split('_')[2] as Country)
      if (adminCountries.length) {
        initStore(adminCountries)
      }
    }
  }, [user, initStore])

  if (!storeInitialized) {
    return (
      <PerInfoBox>
        <InfoBoxTile
          heading={t('hrSupport.empty.heading')}
          headingAlign="center"
          contentAlign="center"
          headingColor="secondary"
          headingMt="xl"
        >
          <PerText>{t('hrSupport.empty.message')}</PerText>
        </InfoBoxTile>
      </PerInfoBox>
    )
  }

  return (
    <ContentContainer collapsed={collapsed}>
      <HrSupportHeader />
      <HrSupportContent />
    </ContentContainer>
  )
}
